

export default class Recaptcha {
  constructor($recaptchaElement) {
    this.interval = null;
    this.$recaptchaTokenElement = $recaptchaElement;
    window.recaptchaCallback = (token) => {
      $recaptchaElement.val(token);
      $('.error-message.recaptcha').hide();
    };
    window.recaptchaTimeoutCallback = () => {
      if(this.interval) {
        this.clearInterval();
        grecaptcha.reset();
      }
    };
  }

  check() {
    grecaptcha.execute();

    return new Promise((resolve) => {
      if(this.interval) {
        this.clearInterval();
      }

      this.interval = setInterval(() => {
        if (this.$recaptchaTokenElement.val().length > 0) {
          this.clearInterval();
          resolve();
        }
      }, 300);
    })
  }

  clearInterval() {
    clearInterval(this.interval);
    this.interval = null;
  }

  reset() {
    grecaptcha.reset();
    this.$recaptchaTokenElement.val('');
  }
}
